import React, { useState } from "react";
import Locandina from "../imgs/LocandinaScuola.jpg";
import Giuseppe from "../imgs/Docenti/giuseppe.jpg";
import Luca from "../imgs/Docenti/Luca Gabbiani.jpg";
import Liliia from "../imgs/Docenti/Liliia Bodnar.jpg";
import Ana from "../imgs/Docenti/Ana Abramovic.jpg";
import Imma from "../imgs/Docenti/Imma Mincolla.jpg";
import Sonia from "../imgs/Docenti/Sonia Franzese.jpg";
import Russo from "../imgs/Docenti/Luca Russo Rossi.jpg";
import Carola from "../imgs/Docenti/Fransca Carola.jpg";
import Silipigni from "../imgs/Docenti/Francesco Silipigni.jpg";
import Fabrizio from "../imgs/Docenti/fabrizio-corbino.jpg";
import Milartefascuola from "../video/milartefascuola.mp4";
import { FaSchool } from "react-icons/fa";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { useForm, ValidationError } from "@formspree/react";

const MilarteFaScuola = () => {
  const [fullScreenImage, setFullScreenImage] = useState(null);
  const handleImageClick = (image) => {
    setFullScreenImage(image);
  };

  const handleClose = () => {
    setFullScreenImage(null);
  };

  const [state, handleSubmit] = useForm("xvgdpaav"); // 👈 sostituisci con il tuo ID

  return (
    <div className="flex flex-col items-center z-10 xs:text-base md:text-xl bg-gradient-to-r from-white to-amber-50 ">
      <FaSchool className="fixed text-amber-200/40 text-[180px] rotate-12 -top-8 -right-5 z-0" />
      <p className="text-red-600 font-extrabold text-3xl md:text-4xl mt-5 tracking-wide mb-5 z-10">
        MILARTE FA SCUOLA
      </p>
      <div className="flex flex-col justify-center text-center w-2/3 z-10">
        <div>
          MilArte propone la nascita di una scuola di musica, con l’intento di
          diffondere la Bellezza del far musica, alla scoperta di un valore
          aggiunto alla persona. Chiunque può avvicinarsi a questa esperienza, a
          qualsiasi età! Non ultimo MilArte desidera coinvolgere giovani che
          possano dare un contributo significativo alle attività pastorali,
          attraverso l’insegnamento del canto, della chitarra e del pianoforte:
          saranno loro poi gli artefici dei canti della S. Messa.
        </div>
        <div className="flex flex-col items-center mt-5">
          <p>Inizio lezioni dal mese di ottobre 2024 dei seguenti strumenti:</p>
          <div className="flex flex-col items-start">
            <p>• Pianoforte</p>
            <p>• Chitarra</p>
            <p>• Violino</p>
            <p>• Flauto</p>
            <p>• Chitarra </p>
            <p>d'accompagnamento</p>
            <p>• Tastiera</p>
            <p>• Organo</p>
            <p>• Clarinetto</p>
            <p>• Tromba</p>
            <p>• Violoncello</p>
            <p>• Coro voci bianche</p>
          </div>
          <p className="mt-6">
            Le lezioni saranno settimanali di 45 minuti presso i locali
            dell’oratorio di S Luigi. Per informazioni scrivere a :
            <div>
              <a
                href="mailto:milarte.mi@gmail.com"
                className="underline text-red-600"
              >
                {" "}
                milarte.mi@gmail.com
              </a>
              {"-"}
              <a
                href="mailto:milarte.mi@pec.it"
                className="underline text-red-600"
              >
                milarte.mi@pec.it
              </a>
            </div>
            <div className="flex justify-center">
              {/* --- SEZIONE NEWSLETTER --- */}
              <div className="w-full flex flex-col items-center text-center mt-8 mb-10 ">
                <h2 className="text-2xl font-bold text-red-600 mb-6">
                  Iscrizione alla Scuola di Musica
                </h2>

                {state.succeeded ? (
                  <p className="text-green-600 text-lg font-semibold">
                    ✅ Grazie per aver inviato la tua iscrizione! Ti
                    contatteremo presto.
                  </p>
                ) : (
                  <form
                    onSubmit={handleSubmit}
                    className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full max-w-4xl bg-white p-8 rounded-2xl shadow-lg text-left"
                  >
                    <input
                      type="hidden"
                      name="_subject"
                      value="Nuova iscrizione Milarte"
                    />

                    {/* --- GENITORE --- */}
                    <h3 className="col-span-full text-xl font-semibold text-gray-800 border-b border-gray-300 pb-1 mb-2">
                      Dati del Genitore
                    </h3>

                    <div className="flex flex-col">
                      <label
                        htmlFor="Nominativo Genitore"
                        className="text-sm font-medium text-gray-700"
                      >
                        Nome e Cognome<a className="text-red-600">*</a>
                      </label>
                      <input
                        id="Nominativo Genitore"
                        name="Nominativo Genitore"
                        type="text"
                        required
                        placeholder="Es. Mario Rossi"
                        className="mt-1 p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
                      />
                    </div>

                    <div className="flex flex-col">
                      <label
                        htmlFor="Numero Telefono Genitore"
                        className="text-sm font-medium text-gray-700"
                      >
                        Numero di Telefono<a className="text-red-600">*</a>
                      </label>
                      <input
                        id="Numero Telefono Genitore"
                        name="Numero Telefono Genitore"
                        type="tel"
                        required
                        placeholder="Es. +39 333 1234567"
                        className="mt-1 p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
                      />
                    </div>

                    <div className="flex flex-col sm:col-span-2">
                      <label
                        htmlFor="Email Genitore"
                        className="text-sm font-medium text-gray-700"
                      >
                        Email<a className="text-red-600">*</a>
                      </label>
                      <input
                        id="Email Genitore"
                        name="Email Genitore"
                        type="email"
                        required
                        placeholder="genitore@email.it"
                        className="mt-1 p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
                      />
                    </div>

                    {/* --- FIGLIO/A --- */}
                    <h3 className="col-span-full text-xl font-semibold text-gray-800 border-b border-gray-300 pb-1 mt-4 mb-2">
                      Dati del Figlio/a
                    </h3>

                    <div className="flex flex-col">
                      <label
                        htmlFor="Nome Figlio/a"
                        className="text-sm font-medium text-gray-700"
                      >
                        Nome e Cognome<a className="text-red-600">*</a>
                      </label>
                      <input
                        id="Nome Figlio/a"
                        name="Nome Figlio/a"
                        type="text"
                        required
                        placeholder="Es. Anna Rossi"
                        className="mt-1 p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
                      />
                    </div>

                    <div className="flex flex-col">
                      <label
                        htmlFor="Telefono Figlio/a"
                        className="text-sm font-medium text-gray-700"
                      >
                        Numero di Telefono
                      </label>
                      <input
                        id="Telefono Figlio/a"
                        name="Telefono Figlio/a"
                        type="tel"
                        placeholder="Es. +39 333 1234567"
                        className="mt-1 p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
                      />
                    </div>

                    <div className="flex flex-col sm:col-span-2">
                      <label
                        htmlFor="Email Figlio/a"
                        className="text-sm font-medium text-gray-700"
                      >
                        Email
                      </label>
                      <input
                        id="Email Figlio/a"
                        name="Email Figlio/a"
                        type="email"
                        placeholder="figlio@gmail.com"
                        className="mt-1 p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
                      />
                    </div>

                    {/* --- NOTE --- */}
                    <div className="flex flex-col sm:col-span-2">
                      <label
                        htmlFor="Note"
                        className="text-sm font-medium text-gray-700"
                      >
                        Note aggiuntive
                      </label>
                      <textarea
                        id="Note"
                        name="Note"
                        rows="4"
                        placeholder="Es. Strumento preferito, orari disponibili, altre informazioni..."
                        className="mt-1 p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
                      />
                    </div>

                    {/* --- BOTTONE --- */}
                    <div className="col-span-full flex justify-center mt-4">
                      <button
                        type="submit"
                        disabled={state.submitting}
                        className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition disabled:opacity-50 font-semibold"
                      >
                        Invia Iscrizione
                      </button>
                    </div>
                  </form>
                )}
              </div>
              {/* --- FINE SEZIONE NEWSLETTER --- */}
            </div>
          </p>
          <div className="z-10">
            <p>
              <a className="text-red-600 underline font-bold" target="_blank">
                IBAN: IT19M0760101600001067558849
              </a>
            </p>
          </div>
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-10 w-full max-w-4xl mx-auto mt-8 z-10">
            <img
              src={Locandina}
              className="w-full md:w-1/2 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-500 ease-in-out cursor-pointer"
              onClick={() => handleImageClick(Locandina)}
              alt="Locandina"
            />
            <video
              controls
              className="w-full md:w-auto max-w-xs rounded-lg shadow-xl"
            >
              <source src={Milartefascuola} type="video/mp4" />
              Il tuo browser non supporta il tag video.
            </video>
          </div>

          {fullScreenImage && (
            <div
              className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
              onClick={handleClose}
            >
              <img
                src={fullScreenImage}
                className="max-w-full max-h-full rounded-lg shadow-lg"
              />
            </div>
          )}

          <h2 className="text-2xl font-bold text-red-600 mt-10 mb-4">
            Docenti
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 w-full max-w-6xl px-4 mb-3">
            {[
              { nome: "Giuseppe Dinardo", img: Giuseppe, sturmento: "Flauto" },
              { nome: "Luca Gabbiani", img: Luca, sturmento: "Contrabbasso" },
              { nome: "Lilla Bodnar", img: Liliia, sturmento: "Violino" },
              { nome: "Ana Abramovic", img: Ana, sturmento: "Corno" },
              { nome: "Imma Mincolla", img: Imma, sturmento: "Oboe" },
              { nome: "Sonia Franzese", img: Sonia, sturmento: "Canto" },
              {
                nome: "Luca Russo Rossi",
                img: Russo,
                sturmento: "Violoncello",
              },
              {
                nome: "Francesca Carola",
                img: Carola,
                sturmento: "Pianoforte",
              },
              {
                nome: "Francesco Silipigni",
                img: Silipigni,
                sturmento: "Clarinetto",
              },
              {
                nome: "Fabrizio Corbino",
                img: Fabrizio,
                sturmento: "Trombone",
              },
            ].map((docente, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center rounded-xl shadow-lg p-4 bg-white hover:shadow-2xl transition transform hover:scale-105"
              >
                <img
                  src={docente.img}
                  alt={docente.nome}
                  className="w-36 h-36 object-cover rounded-full mb-3"
                />
                <p className="font-semibold text-base text-gray-800">
                  <em>{docente.nome}</em>
                  <br />
                  <strong>Docente di {docente.sturmento}</strong>
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MilarteFaScuola;
